import React from 'react';
import { createPortal } from 'react-dom';
import CodeLanguageSelect from './code-language-select';
const CodeLanguagePlugin = ({
  anchorElem
}: {
  anchorElem: HTMLElement;
}) => {
  // As we do not have the control to change the CodeNode as it is imported from a lexical, we can't wrap the code node along with the code language select component.
  // So, we need to use createPortal to render the CodeLanguageSelect component outside the CodeNode.
  return createPortal(<CodeLanguageSelect anchorElem={anchorElem} />, anchorElem);
};
export default CodeLanguagePlugin;